<template>
  <div class="classes-satisfied d-flex flex-row">
    <Badge v-bind="badgeProps" class="mr-2" />
    <div class="ml-auto mt-1">
      <a
        :href="editInvoiceLink"
        class="action-link"
        data-turbo-frame="slide_panel"
        data-action="slide-panel#open"
        :data-slide-panel-title-param="slideoutTitle"
      >
        <i class="fas fa-edit ml-1 link"></i>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import Badge from "@/components/Badge.vue";

const props = defineProps({
  invoiceId: {
    type: [String, Number],
    default: ""
  },
  editInvoiceLink: {
    type: String,
    default: ""
  }
});

const store = useStore();

const badgeProps = computed(() => {
  const status = store.state.invoices[props.invoiceId].accounting_class_status;
  const trackClassesByLineItem = store.getters.trackClassesByLineItem;

  if (status === "invalid") {
    return {
      text: "Invalid",
      color: "red",
      icon: "fa-octagon-exclamation",
      tooltipText:
        (trackClassesByLineItem
          ? "The line items belong to this invoice have accounting classes set, but one or more are not valid for sending to QuickBooks. "
          : "This invoice has an accounting class set, but it is not valid for sending to QuickBooks. ") +
        "Please ensure that your accounting classes are verified with QuickBooks via the Company -> Settings screen."
    };
  } else if (status === "ready") {
    return {
      text: "Assigned",
      color: "gray",
      tooltipText: trackClassesByLineItem
        ? "The line items on this invoice have valid accounting classes assigned."
        : "This invoice has a valid accounting class assigned."
    };
  } else {
    return {
      text: "Unassigned",
      color: "yellow",
      icon: "fa-triangle-exclamation",
      tooltipText: trackClassesByLineItem
        ? "The line items of this invoice do not have accounting classes assigned."
        : "This invoice does not have an accounting class assigned."
    };
  }
});

const slideoutTitle = computed(() => {
  const trackClassesByLineItem = store.getters.trackClassesByLineItem;

  if (trackClassesByLineItem) {
    return `Edit Invoice ${props.invoiceId} Accounting Classes`;
  } else {
    return `Edit Invoice ${props.invoiceId} Accounting Class`;
  }
});
</script>
